import { render } from "./PlayerComp.vue?vue&type=template&id=7996de69&scoped=true"
import script from "./PlayerComp.vue?vue&type=script&lang=js"
export * from "./PlayerComp.vue?vue&type=script&lang=js"

import "./PlayerComp.vue?vue&type=style&index=0&id=7996de69&scoped=true&lang=css"
import "./PlayerComp.vue?vue&type=style&index=1&id=7996de69&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7996de69"]])

export default __exports__